import React from "react";
import { ThemeProvider } from "@material-ui/core";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { useSelector } from "react-redux";
import * as loginActions from "./redux/actions/login.action";

import Header from "./components/fragments/Header";
import Menu from "./components/fragments/Menu";
import Login from "./components/pages/Login";

import Dashboard from "./components/pages/Dashboard";

// Error Handler
import NotFound from "./components/pages/errors/NotFound";

//Budget Module
import BudgetForecastComponent from "./components/pages/budget/BudgetForecastComponent";
import BudgetForecastMonthlyComponent from "./components/pages/budget/BudgetForecastMonthlyComponent";
import ApproveBudgetComponent from "./components/pages/budget/ApproveBudgetComponent";
import ManagerReportByBrandComponent from "./components/pages/budget/ManagerReportByBrandComponent";
import ManagerReportByDeptComponent from "./components/pages/budget/ManagerReportByDeptComponent";
import ManagerReportDetailByBrandComponent from "./components/pages/budget/ManagerReportDetailByBrandComponent";
import SpecialComponent from "./components/pages/budget/SpecialComponent";
import BudgetCompareReportByBrandComponent from "./components/pages/budget/BudgetCompareReportByBrandComponent";
import BudgetCompareReportByDeptComponent from "./components/pages/budget/BudgetCompareReportByDeptComponent";
import ExpensesComponent from "./components/pages/budget/ExpensesComponent";

// Purchase Requisition Module
import ExpenseEditComponent from "./components/pages/purchase-requisition/ExpenseEditComponent";
import ExpenseJobEditComponent from "./components/pages/purchase-requisition/ExpenseJobEditComponent";
import PurchaseEditComponent from "src/views/PurchaseEditComponent";
import PurchaseRequisitionList from "src/views/PurchaseRequisitionList";
import RemarkEditComponent from "./components/pages/purchase-requisition/RemarkEditComponent";
import PurchaseJobComponent from "./components/pages/purchase-requisition/PurchaseJobComponent";
import PurchaseJobEditComponent from "./components/pages/purchase-requisition/PurchaseJobEditComponent";
import PurchaseJobItemEditComponent from "./components/pages/purchase-requisition/PurchaseJobItemEditComponent";
import PrintPurchaseRequisitionComponent from "./components/pages/purchase-requisition/PrintPurchaseRequisitionComponent";
import BudgetManagementComponent from "./components/pages/purchase-requisition/BudgetManagementComponent";
import PurchaseJobItemAddComponent from "./components/pages/purchase-requisition/PurchaseJobItemAddComponent/PurchaseJobItemAddComponent";
import RemarkJobEditComponent from "./components/pages/purchase-requisition/RemarkJobEditComponent/RemarkJobEditComponent";
import RemarkStatusComponent from "./components/pages/purchase-requisition/RemarkStatusComponent";
import BudgetAdjustmentRequisitionComponent from "src/components/pages/purchase-requisition/BudgetAdjustmentRequisitionComponent";

// Settings Module
import UserManagementSettingComponent from "src/components/pages/settings/UserManagementSettingComponent";
import RoleManagementSettingComponent from "./components/pages/settings/RoleManagementSettingComponent";
import RoleManagementEditSettingComponent from "./components/pages/settings/RoleManagementEditSettingComponent";
import PermissionManagementSettingComponent from "./components/pages/settings/PermissionManagementSettingComponent";

// Report Module
import SummaryInvestmentCAPAXComponent from "src/components/pages/report/SummaryInvestmentCAPAXComponent";
import PurchaseRequestReportComponent from "src/components/pages/report/PurchaseRequestReportComponent";
import TransactionTrackingComponent from "src/components/pages/report/TransactionTrackingComponent";
import SummaryExpenseOPEXComponent from "src/components/pages/report/SummaryExpenseOPEXComponent";
import RefListReportComponent from "src/components/pages/report/RefListReportComponent";
import AdjustmentListReportComponent from "./components/pages/report/AdjustmentListReportComponent";
import BudgetAdjustmentReportComponent from "./components/pages/report/BudgetAdjustmentReportComponent";

// Auth Module
import PrivateRoute from "./utils/PrivateRoute";

import clsx from "clsx";

import theme from "src/theme";
import GlobalStyles from "./components/GlobalStyles";

import { makeStyles } from "@material-ui/core/styles";
import BudgetCodeSelectionComponent from "./components/pages/purchase-requisition/BudgetCodeSelectionComponent";
import CreateBudgetRequisitionComponent from "./components/pages/purchase-requisition/CreateBudgetRequisitionComponent";
import EditBudgetRequisitionComponent from "./components/pages/purchase-requisition/EditBudgetRequisitionComponent";
import ReviewBudgetAdjustmentRequisitionComponent from "./components/pages/purchase-requisition/ReviewBudgetAdjustmentRequisitionComponent";
import VerifyBudgetAdjustmentRequisitionComponent from "./components/pages/purchase-requisition/VerifyBudgetAdjustmentRequisitionComponent";
import SummaryInvestmentDetailComponent from "./components/pages/report/SummaryInvestmentDetailComponent";
import SummaryExpenseDetailComponent from "./components/pages/report/SummaryExpenseDetailComponent";
import PRStatusReportComponent from "./components/pages/report/PRStatusReportComponent";
import UserProfileComponent from "./components/pages/settings/UserProfileComponent";
import UserProfileEditComponent from "./components/pages/settings/UserProfileEditComponent";
import PRListApproverPage from "./views/PRListApproverPage";
import PRListReviewerPage from "./views/PRListReviewerPage";
import SearchContactPage from "./views/SearchContactPage";
import CreateContactPage from "./views/CreateContactPage";
import ConditionContractSearchPage from "./views/ConditionContractSearchPage";
import OverPeriodApprover from "./views/OverPeriodApprover";
import PRReviewerCreatePage from "./views/PRReviewerCreatePage";
import PRApproverCreatePage from "./views/PRApproverCreatePage";
import PrintPurchaseRequistionPage from "./views/PrintPurchaseRequistionPage";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  contentMain: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1),
    paddingTop: theme.spacing(3),
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 40,
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
}));

export default function App() {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const loginReducer = useSelector((state) => state.loginReducer);

  const LoginRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        loginActions.isLoggedIn() ? (
          <Redirect to="/dashboard" />
        ) : (
          <Login {...props} />
        )
      }
    />
  );

  return (
    <Router basename="/prs">
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {loginReducer.result && !loginReducer.error && (
          <Header handleDrawerOpen={handleDrawerOpen} open={openDrawer} />
        )}
        {loginReducer.result && !loginReducer.error && (
          <Menu
            openDrawer={openDrawer}
            userInfo={loginReducer.result}
            handleDrawerClose={handleDrawerClose}
          />
        )}
        <main
          className={clsx({
            [classes.contentShift]:
              openDrawer && loginReducer.result && !loginReducer.error,
          })}
        >
          <div className={classes.wrapper}>
            <div className={classes.contentContainer}>
              <div
                className={clsx(classes.contentMain, {
                  [classes.content]: loginReducer.result && !loginReducer.error,
                })}
              >
                <Switch>
                  <LoginRoute path={`/login`} component={Login} />
                  <PrivateRoute path={`/budgetrequest`}>
                    <ExpensesComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/specialowner`}>
                    <SpecialComponent />
                  </PrivateRoute>
                  <PrivateRoute exact path={`/dashboard`}>
                    <Dashboard />
                  </PrivateRoute>
                  <PrivateRoute path={`/approve-budget`}>
                    <ApproveBudgetComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/manager-report-detail`}>
                    <ManagerReportDetailByBrandComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budgetforecast`}>
                    <BudgetForecastComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/reportbudgetfinalbybrand`}>
                    <ManagerReportByBrandComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/reportbudgetfinalbydepartment`}>
                    <ManagerReportByDeptComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/pr-list-approver`}>
                    <PRListApproverPage />
                  </PrivateRoute>
                  <PrivateRoute path={`/pr-list-reviewer`}>
                    <PRListReviewerPage />
                  </PrivateRoute>
                  <PrivateRoute path={`/search-contact`}>
                    <SearchContactPage />
                  </PrivateRoute>
                  <PrivateRoute path={`/create-contact/:id`}>
                    <CreateContactPage />
                  </PrivateRoute>
                  <PrivateRoute path={`/condition-contact-search`}>
                    <ConditionContractSearchPage />
                  </PrivateRoute>
                  {/* Purchase Requisition User */}
                  <PrivateRoute path={`/purchase-requisition-remark/:id/:prno`}>
                    <RemarkStatusComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/purchase-requisition-list`}>
                    <PurchaseRequisitionList />
                  </PrivateRoute>
                  <PrivateRoute path={`/edit-purchase-requisition/:id`}>
                    <PurchaseEditComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/edit-pr-reviewer/:id`}>
                    <PRReviewerCreatePage />
                  </PrivateRoute>
                  <PrivateRoute path={`/edit-pr-approver/:id`}>
                    <PRApproverCreatePage />
                  </PrivateRoute>
                  <PrivateRoute path={`/print-purchase-requisition/:id`}>
                    <PrintPurchaseRequisitionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/print-pr/:id`}>
                    <PrintPurchaseRequistionPage />
                  </PrivateRoute>
                  <PrivateRoute
                    path={`/purchase-requisition-detail-remark/:id`}
                  >
                    <RemarkEditComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/purchase-expense-edit/:id`}>
                    <ExpenseEditComponent />
                  </PrivateRoute>
                  {/* Purchase Staff Page */}
                  <PrivateRoute path={`/purchase-requisition-job`}>
                    <PurchaseJobComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/purchase-edit-job/:id`}>
                    <PurchaseJobEditComponent />
                  </PrivateRoute>
                  <PrivateRoute
                    path={`/purchase-edit-job-item/:id/:year/:countryid/:companyid/:headerid/:secid/:budgetcode`}
                  >
                    <PurchaseJobItemEditComponent />
                  </PrivateRoute>
                  <PrivateRoute
                    path={`/purchase-add-job-item/:headerid/:year/:countryid/:companyid/:secid`}
                  >
                    <PurchaseJobItemAddComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/purchase-expense-edit-job/:id`}>
                    <ExpenseJobEditComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/item-remark-edit-job/:id`}>
                    <RemarkJobEditComponent />
                  </PrivateRoute>
                  {/* Setting Page */}
                  <PrivateRoute path={`/over-period-approver`}>
                    <OverPeriodApprover />
                  </PrivateRoute>
                  <PrivateRoute path={`/user-profile`}>
                    <UserProfileComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/user-profile-edit/:id`}>
                    <UserProfileEditComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/user-management-setting`}>
                    <UserManagementSettingComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/role-management-setting`}>
                    <RoleManagementSettingComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/role-management-edit/:id`}>
                    <RoleManagementEditSettingComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/permission-management-setting`}>
                    <PermissionManagementSettingComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budget-management`}>
                    <BudgetManagementComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budgetforecastmonthly`}>
                    <BudgetForecastMonthlyComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budgetcomparebybrand`}>
                    <BudgetCompareReportByBrandComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budgetcomparebydept`}>
                    <BudgetCompareReportByDeptComponent />
                  </PrivateRoute>
                  {/* Report Module */}
                  <PrivateRoute path={`/summary-investment-capax`}>
                    <SummaryInvestmentCAPAXComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/summary-investment-detail`}>
                    <SummaryInvestmentDetailComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/summery-expense-opex`}>
                    <SummaryExpenseOPEXComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/summery-expense-detail`}>
                    <SummaryExpenseDetailComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budget-adjustment-report`}>
                    <BudgetAdjustmentReportComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/transaction-tracking`}>
                    <TransactionTrackingComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/adjustment-list-report`}>
                    <AdjustmentListReportComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/ref-list-report`}>
                    <RefListReportComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/purchase-request-report`}>
                    <PurchaseRequestReportComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/pr-status-report`}>
                    <PRStatusReportComponent />
                  </PrivateRoute>
                  {/* End Report Module */}
                  <PrivateRoute path={`/budget-adjustment-requisition`}>
                    <BudgetAdjustmentRequisitionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/review-budget-adjustment-requisition`}>
                    <ReviewBudgetAdjustmentRequisitionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/verify-budget-adjustment-requisition`}>
                    <VerifyBudgetAdjustmentRequisitionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/budget-code-selection`}>
                    <BudgetCodeSelectionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/create-budget-adjustment-requisition`}>
                    <CreateBudgetRequisitionComponent />
                  </PrivateRoute>
                  <PrivateRoute path={`/edit-budget-adjustment-requisition`}>
                    <EditBudgetRequisitionComponent />
                  </PrivateRoute>
                  <Route
                    exact
                    path="/"
                    component={() => <Redirect to="/login" />}
                  />
                  <Route component={NotFound} />
                </Switch>
              </div>
            </div>
          </div>
        </main>
      </ThemeProvider>
    </Router>
  );
}
